import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

//import { UntypedFormControl/*, ReactiveFormsModule*/ } from '@angular/forms';

//import { Observable, combineLatest, BehaviorSubject, Subject, ReplaySubject } from 'rxjs';

import { filter } from 'rxjs/operators';
//import { DefaultIndexDoc } from '@app/graphql';

import { sortOptions, SortBy, PageName } from '@app/constants';

import { DataService } from '@app/data';

//import { MatRadioChange } from '@angular/material/radio';

@Component({
  selector: 'app-sort',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.less']
})
export class SortComponent implements OnInit {

  @Input() sortBy!: SortBy;
  @Input() queryParams!: any;

  public sortOptions = sortOptions;
  
  //public sortByControl: UntypedFormControl | any;

  constructor(
    private data: DataService
  ) {}

  ngOnInit(): void {
    //console.log('SortComponent ngOnInit this.sortBy', this.sortBy);

    /*if (this.sortBy) {
      this.sortByControl  = new UntypedFormControl(this.sortBy.value);
    }*/
  }

  public getQueryParams = (option: any): any => {
    //console.log('SortComponent getQueryParams option', option);
    //console.log('SortComponent getQueryParams this.queryParams', this.queryParams);

    let newQueryParams = {...this.queryParams};

    if (newQueryParams.seradit) {
      delete newQueryParams.seradit;
    }
    
    if(newQueryParams.page) {
      delete newQueryParams.page;
    }

    if (option.value !== 'created-DESC') {
      newQueryParams['seradit'] = option.value;
    }
    
    return newQueryParams;
  }

  public isSelected = (option: any): boolean => {
    //console.log('SortComponent isSelected option', option);
    //console.log('SortComponent isSelected this.queryParams', this.queryParams);

    let selected = false;

    if (this.queryParams.seradit) {
      selected = this.queryParams.seradit === option.value ? true : false;
    }
    else if (option.value === 'created-DESC') {
      selected = true;
    }

    return selected;
  }

  
}
